import { Loader2 } from 'lucide-react';

export const defaultLoadingBox =
  <div className="flex flex-col items-center justify-center h-screen">
    <Loader2 className="h-12 w-12 animate-spin text-primary" />
    <p className="text-muted-foreground mt-4">로딩 중...</p>
  </div>
